<template>
	<div class="position">
		<div>
			<h3 class="popup-tilte">Igazold vissza, hogy te vagy az!</h3>
			<div class="fs-desc popup-content-width">
				Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ante mi, scelerisque at accumsan vitae,
				vehicula sit amet turpis. Morbi dictum metus eu purus vestibulum pulvinar. Lorem ipsum dolor sit amet,
				consectetur adipiscing elit. Vivamus ante mi, scelerisque at accumsan vitae, vehicula sit amet turpis.
				Morbi dictum metus eu purus vestibulum pulvinar. Lorem ipsum dolor sit amet, consectetur adipiscing
				elit. Vivamus ante mi, scelerisque at accumsan vitae, vehicula sit amet turpis. Morbi dictum metus eu
				purus vestibulum pulvinar.
			</div>
		</div>
	</div>
</template>

<script>
export default {};
</script>
